import React from 'react';
import Alert from 'react-bootstrap/Alert';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { LANGUAGE_NAMES, DEFAULT_LANGUAGE } from '../../../../service/constants';

const MarkersSection = ({ 
    times, 
    onTimeChange, 
    onAddTime, 
    onDeleteTime, 
    timeErrors, 
    isTranslation = false,
    lang = DEFAULT_LANGUAGE
}) => {
    const languageLabel = LANGUAGE_NAMES[lang] || "";
    const languageSuffix = ` (${languageLabel})`;
    
    return (
        <div className="form-group">
            <label>Marcadores{languageSuffix}</label>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="">Nombre</th>
                        <th scope="">Tiempo</th>
                        {!isTranslation && <th scope=""></th>}
                    </tr>
                </thead>
                <tbody>
                    {times && times.length > 0 ? times.map((time, index) => {
                        const timeValue = isTranslation && time.translatedName !== undefined 
                            ? time.translatedName 
                            : (time.name || "")
                        const timeDisplay = time.time || ""
                        return (
                            <tr key={index}>
                                <td>
                                    <input 
                                        name="name" 
                                        id={index} 
                                        onChange={(e) => onTimeChange(index, "name", e.target.value)}
                                        value={timeValue} 
                                        type="text" 
                                        className="form-control" 
                                    />
                                    <Alert show={!!timeErrors[`name_${index}`]} className="mt-2" variant="danger">
                                        {timeErrors[`name_${index}`]}
                                    </Alert>
                                </td>
                                <td>
                                    {isTranslation ? (
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={timeDisplay} 
                                            disabled 
                                        />
                                    ) : (
                                        <>
                                            <MaskedFormControl 
                                                name="time" 
                                                id={`${index}`} 
                                                onChange={(e) => onTimeChange(index, "time", e.target.value)} 
                                                value={time.time || ""} 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="hh:mm:ss" 
                                                mask='1:11:11' 
                                            />
                                            <Alert show={!!timeErrors[`time_${index}`]} className="mt-2" variant="danger">
                                                {timeErrors[`time_${index}`]}
                                            </Alert>
                                        </>
                                    )}
                                </td>
                                {!isTranslation && (
                                    <td>
                                        <a className="text-light btn btn-primary" onClick={() => onDeleteTime(index)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </a>
                                    </td>
                                )}
                            </tr>
                        )
                    }) : (
                        <tr>
                            <td colSpan={isTranslation ? 2 : 3} className="text-center">
                                No hay marcadores definidos. Agrega marcadores en el idioma base primero.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {!isTranslation && (
                <button className="btn btn-primary btn-block" type="button" onClick={onAddTime}>
                    Agregar nuevo marcador
                </button>
            )}
        </div>
    );
};

export default MarkersSection;
